import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addAllowImpersonationUserRequest = {};
var _addAllowImpersonationUserResponse = {};
var _createMagicLinkRequest = {};
var _createMagicLinkResponse = {};
var _createStubUserRequest = {};
var _createUserRequest = {};
var _createUserResponse = {};
var _empty = {};
var _get2FASettingsRequest = {};
var _get2FASettingsResponse = {};
var _getAllowImpersonationUsersRequest = {};
var _getAllowImpersonationUsersResponse = {};
var _getSsoSettingsRequest = {};
var _getSsoSettingsResponse = {};
var _isAllowImpersonationRequest = {};
var _isAllowImpersonationResponse = {};
var _isEmailExistsRequest = {};
var _isEmailExistsResponse = {};
var _isSsoMandatoryRequest = {};
var _isSsoMandatoryResponse = {};
var _rawHttpResponse = { body: 'BYTES' };
var _remove2FASettingsRequest = {};
var _remove2FASettingsResponse = {};
var _removeAllowImpersonationUserRequest = {};
var _removeAllowImpersonationUserResponse = {};
var _set2FASettingsRequest = {};
var _set2FASettingsResponse = {};
var _setMy2FASettingsRequest = {};
var _setMy2FASettingsResponse = {};
var _setUserEmailAsVerifiedRequest = {};
var _setUserEmailAsVerifiedResponse = {};
var _testSessionValidationResponse = {};
var _updateEmailRequest = {};
var _updateExternalDataRequest = {};
var _updateExternalDataResponse = {};
var _userAccountsDataByEmailResponse = {};
var _userByEmailRequest = {};
var _userByEmailResponse = {};
var _usersAccountsDataByEmailRequest = {};
function resolveComWixpressUsersUrl(opts) {
    var domainToMappings = {
        'users._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/m/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/signin/oauth',
                destPath: '/login/form/oauth',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/logo',
                destPath: '/logo',
            },
            {
                srcPath: '/apple-album',
                destPath: '/apple-album',
            },
            {
                srcPath: '/oneapp',
                destPath: '/oneapp',
            },
            {
                srcPath: '/videomaker',
                destPath: '/videomaker',
            },
            {
                srcPath: '/user/sendVerifyEmailOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/_api/v1/stub-users',
                destPath: '/v1/stub-users',
            },
            {
                srcPath: '/_api/v1/users',
                destPath: '/v1/users',
            },
            {
                srcPath: '/_api/v1/magic-link',
                destPath: '/v1/magic-link',
            },
            {
                srcPath: '/auth/v2/login',
                destPath: '/auth/v2/login',
            },
            {
                srcPath: '/hype',
                destPath: '/hype',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/.well-known/assetlinks.json',
                destPath: '/api/.well-known/assetlinks.json',
            },
            {
                srcPath: '/hopp',
                destPath: '/hopp',
            },
            {
                srcPath: '/dayful',
                destPath: '/dayful',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
            {
                srcPath: '/codux',
                destPath: '/codux',
            },
            {
                srcPath: '/headless',
                destPath: '/headless',
            },
            {
                srcPath: '/_api/v1/account-recovery/verify-code',
                destPath: '/v1/users/account-recovery/verify-code',
            },
            {
                srcPath: '/_api/v1/account-recovery/send-code',
                destPath: '/v1/users/account-recovery/send-code',
            },
        ],
        'sslusers._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'pmmusers._base_domain_': [
            {
                srcPath: '/wix-users',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmail',
                destPath: '/link/verifyUserEmail',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneApp',
                destPath: '/link/verifyUserEmailOneApp',
            },
            {
                srcPath: '/lp-mob/mobjohnbuildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/freesitebuilder/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneAppWeb',
                destPath: '/link/verifyUserEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/sendVerifyEmailByOneAppWeb',
                destPath: '/api/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/user/sendVerifyEmailByOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/m/sendVerifyEmailByOneAppWeb',
                destPath: '/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/mob-en/createcomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/mob-en/buildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/.well-known/assetlinks.json',
                destPath: '/api/.well-known/assetlinks.json',
            },
            {
                srcPath: '/blog/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/account-users/update-email',
                destPath: '/v1/account-users/update-email',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-html-login-webapp',
                destPath: '',
            },
            {
                srcPath: '/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'support._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/users-login',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/users-login',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/user/getUserDetails',
                destPath: '/user/getUserDetails',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/freesitebuilder/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohnbuildercomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/lp-mob/mobjohncreatecomp',
                destPath: '/login/form',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmail',
                destPath: '/link/verifyUserEmail',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneApp',
                destPath: '/link/verifyUserEmailOneApp',
            },
            {
                srcPath: '/wix-users/link/verifyUserEmailOneAppWeb',
                destPath: '/link/verifyUserEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/m/sendVerifyEmailByOneAppWeb',
                destPath: '/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/sendVerifyEmailByOneAppWeb',
                destPath: '/api/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/wix-users/user/sendVerifyEmailByOneAppWeb',
                destPath: '/user/sendVerifyEmailOneAppWeb',
            },
            {
                srcPath: '/_api/wix-html-login-webapp',
                destPath: '/api',
            },
            {
                srcPath: '/wix-users/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/wix-users/auth/setLanguage',
                destPath: '/auth/setLanguage',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
            {
                srcPath: '/switch-account',
                destPath: '/v1/users/switch-account',
            },
            {
                srcPath: '/wix-users/v1/users/initiate-authentication',
                destPath: '/v1/users/initiate-authentication',
            },
            {
                srcPath: '/wix-users/v1/users/execute-authentication',
                destPath: '/v1/users/execute-authentication',
            },
            {
                srcPath: '/wix-users/v1/users/set-my-password',
                destPath: '/v1/users/set-my-password',
            },
            {
                srcPath: '/wix-users/v1/users/twofa-settings',
                destPath: '/v1/users/twofa-settings',
            },
        ],
        'api.wixpress.com': [
            {
                srcPath: '/wix-html-login-webapp',
                destPath: '',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/_api/wix-html-login-webapp/users/email',
                destPath: '/v1/users/email',
            },
        ],
        'online.codux.com': [
            {
                srcPath: '/signin',
                destPath: '/login/form',
            },
            {
                srcPath: '/auth',
                destPath: '/auth',
            },
            {
                srcPath: '/v1/userAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/social',
                destPath: '/social',
            },
            {
                srcPath: '/signout',
                destPath: '/auth/logout',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/getUserAccountsByEmail',
                destPath: '/v1/userAccountsByEmail',
            },
            {
                srcPath: '/_api/wix-html-login-webapp/auth/forgotPassword',
                destPath: '/auth/forgotPassword',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressUsersTestappTestSessionValidationServiceUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function sessionValidationThroughAspects(payload) {
    var _a = serializer(_empty, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_testSessionValidationResponse, {}).fromJSON;
    function __sessionValidationThroughAspects(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'GET',
            methodFqn: 'com.wixpress.users.testapp.TestSessionValidationService.SessionValidationThroughAspects',
            url: resolveComWixpressUsersTestappTestSessionValidationServiceUrl({
                protoPath: '/testSessionValidationThroughAspects',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sessionValidationThroughAspects.fromReq = fromReq;
    __sessionValidationThroughAspects.__isAmbassador = true;
    return __sessionValidationThroughAspects;
}
/**
 * This method should be used for creating stub users, which are not real Wix users - they can't login, and have no valid email.
 * The use case is, for example: creating a stub user for billing purposes via Wix-Billing (which must have a User entity), made by an external app
 */
export function createStubUser(payload) {
    var _a = serializer(_createStubUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createUserResponse, {}).fromJSON;
    function __createStubUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'POST',
            methodFqn: 'com.wixpress.Users.createStubUser',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/stub-users',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createStubUser.fromReq = fromReq;
    __createStubUser.__isAmbassador = true;
    return __createStubUser;
}
export function createUser(payload) {
    var _a = serializer(_createUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createUserResponse, {}).fromJSON;
    function __createUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'POST',
            methodFqn: 'com.wixpress.Users.createUser',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createUser.fromReq = fromReq;
    __createUser.__isAmbassador = true;
    return __createUser;
}
/** returns wix userId, if a user with the given email exists, 404 otherwise */
export function getUserByEmail(payload) {
    var _a = serializer(_userByEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_userByEmailResponse, {}).fromJSON;
    function __getUserByEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'GET',
            methodFqn: 'com.wixpress.Users.getUserByEmail',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUserByEmail.fromReq = fromReq;
    __getUserByEmail.__isAmbassador = true;
    return __getUserByEmail;
}
/**
 * Updates user's externalData, which is:
 * - clientId (aka. appDefId) - provided implicitly in Identity (i.e: in accessToken's data)
 * - externalId - external user's id
 */
export function updateUser(payload) {
    var _a = serializer(_updateExternalDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExternalDataResponse, {}).fromJSON;
    function __updateUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'PATCH',
            methodFqn: 'com.wixpress.Users.updateUser',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/{userId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateUser.fromReq = fromReq;
    __updateUser.__isAmbassador = true;
    return __updateUser;
}
export function createMagicLink(payload) {
    var _a = serializer(_createMagicLinkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMagicLinkResponse, {}).fromJSON;
    function __createMagicLink(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'POST',
            methodFqn: 'com.wixpress.Users.createMagicLink',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/magic-link',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMagicLink.fromReq = fromReq;
    __createMagicLink.__isAmbassador = true;
    return __createMagicLink;
}
export function setUserEmailAsVerified(payload) {
    var _a = serializer(_setUserEmailAsVerifiedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setUserEmailAsVerifiedResponse, {}).fromJSON;
    function __setUserEmailAsVerified(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'PUT',
            methodFqn: 'com.wixpress.Users.setUserEmailAsVerified',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setUserEmailAsVerified.fromReq = fromReq;
    __setUserEmailAsVerified.__isAmbassador = true;
    return __setUserEmailAsVerified;
}
export function set2FaSettings(payload) {
    var _a = serializer(_set2FASettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_set2FASettingsResponse, {}).fromJSON;
    function __set2FaSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'PUT',
            methodFqn: 'com.wixpress.Users.set2FASettings',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/twofa-settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __set2FaSettings.fromReq = fromReq;
    __set2FaSettings.__isAmbassador = true;
    return __set2FaSettings;
}
export function setMy2FaSettings(payload) {
    var _a = serializer(_setMy2FASettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setMy2FASettingsResponse, {}).fromJSON;
    function __setMy2FaSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'PUT',
            methodFqn: 'com.wixpress.Users.setMy2FASettings',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/my/twofa-settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setMy2FaSettings.fromReq = fromReq;
    __setMy2FaSettings.__isAmbassador = true;
    return __setMy2FaSettings;
}
export function remove2FaSettings(payload) {
    var _a = serializer(_remove2FASettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_remove2FASettingsResponse, {}).fromJSON;
    function __remove2FaSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'DELETE',
            methodFqn: 'com.wixpress.Users.remove2FASettings',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/twofa-settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __remove2FaSettings.fromReq = fromReq;
    __remove2FaSettings.__isAmbassador = true;
    return __remove2FaSettings;
}
export function get2FaSettings(payload) {
    var _a = serializer(_get2FASettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_get2FASettingsResponse, {}).fromJSON;
    function __get2FaSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'GET',
            methodFqn: 'com.wixpress.Users.get2FASettings',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/twofa-settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __get2FaSettings.fromReq = fromReq;
    __get2FaSettings.__isAmbassador = true;
    return __get2FaSettings;
}
export function getSsoSettings(payload) {
    var _a = serializer(_getSsoSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSsoSettingsResponse, {}).fromJSON;
    function __getSsoSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'GET',
            methodFqn: 'com.wixpress.Users.getSsoSettings',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/sso-settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSsoSettings.fromReq = fromReq;
    __getSsoSettings.__isAmbassador = true;
    return __getSsoSettings;
}
/**
 * checks if user is assigned to account which force login using SSO
 * the user data is extracted implicitly from identity aspects
 */
export function isSsoMandatory(payload) {
    var _a = serializer(_isSsoMandatoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_isSsoMandatoryResponse, {}).fromJSON;
    function __isSsoMandatory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'GET',
            methodFqn: 'com.wixpress.Users.isSsoMandatory',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/is-mandatory-sso',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __isSsoMandatory.fromReq = fromReq;
    __isSsoMandatory.__isAmbassador = true;
    return __isSsoMandatory;
}
/**
 * returns list of all users with given email if exist, 404 otherwise (used to display account selector)
 * TODO: protect with permissions?
 */
export function getUserAccountsByEmail(payload) {
    var _a = serializer(_usersAccountsDataByEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_userAccountsDataByEmailResponse, {}).fromJSON;
    function __getUserAccountsByEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'POST',
            methodFqn: 'com.wixpress.Users.getUserAccountsByEmail',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/userAccountsByEmail',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveComWixpressUsersUrl({
                        protoPath: '/v1/userAccountsByEmail',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __getUserAccountsByEmail.fromReq = fromReq;
    __getUserAccountsByEmail.__isAmbassador = true;
    return __getUserAccountsByEmail;
}
/**
 * updates the user email.
 * newEmail - extracted from `actionTag` of the verification process
 * userId - extracted from identity
 */
export function updateEmail(payload) {
    var _a = serializer(_updateEmailRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __updateEmail(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'PUT',
            methodFqn: 'com.wixpress.Users.UpdateEmail',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/email',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateEmail.fromReq = fromReq;
    __updateEmail.__isAmbassador = true;
    return __updateEmail;
}
/** checks if a user exists with that email. */
export function isEmailExists(payload) {
    var _a = serializer(_isEmailExistsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_isEmailExistsResponse, {}).fromJSON;
    function __isEmailExists(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'GET',
            methodFqn: 'com.wixpress.Users.isEmailExists',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/emails',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __isEmailExists.fromReq = fromReq;
    __isEmailExists.__isAmbassador = true;
    return __isEmailExists;
}
/** get for the current login user, all it's allow impersonate user ids list */
export function getAllowImpersonationUsers(payload) {
    var _a = serializer(_getAllowImpersonationUsersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAllowImpersonationUsersResponse, {}).fromJSON;
    function __getAllowImpersonationUsers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'GET',
            methodFqn: 'com.wixpress.Users.GetAllowImpersonationUsers',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/get-allow-impersonate-users',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAllowImpersonationUsers.fromReq = fromReq;
    __getAllowImpersonationUsers.__isAmbassador = true;
    return __getAllowImpersonationUsers;
}
/** check if the current login user, allow impersonate target user id */
export function isAllowImpersonation(payload) {
    var _a = serializer(_isAllowImpersonationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_isAllowImpersonationResponse, {}).fromJSON;
    function __isAllowImpersonation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'GET',
            methodFqn: 'com.wixpress.Users.IsAllowImpersonation',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/is-allow-impersonate',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __isAllowImpersonation.fromReq = fromReq;
    __isAllowImpersonation.__isAmbassador = true;
    return __isAllowImpersonation;
}
/** add for the current login user, new user id to the allow impersonate user ids list */
export function addAllowImpersonationUser(payload) {
    var _a = serializer(_addAllowImpersonationUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addAllowImpersonationUserResponse, {}).fromJSON;
    function __addAllowImpersonationUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'GET',
            methodFqn: 'com.wixpress.Users.AddAllowImpersonationUser',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/add-allow-impersonate-user',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addAllowImpersonationUser.fromReq = fromReq;
    __addAllowImpersonationUser.__isAmbassador = true;
    return __addAllowImpersonationUser;
}
/** remove for the current login user, user id from the allow impersonate user ids list */
export function removeAllowImpersonationUser(payload) {
    var _a = serializer(_removeAllowImpersonationUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeAllowImpersonationUserResponse, {}).fromJSON;
    function __removeAllowImpersonationUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.users.v1.example',
            method: 'GET',
            methodFqn: 'com.wixpress.Users.RemoveAllowImpersonationUser',
            url: resolveComWixpressUsersUrl({
                protoPath: '/v1/users/remove-allow-impersonate-user',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeAllowImpersonationUser.fromReq = fromReq;
    __removeAllowImpersonationUser.__isAmbassador = true;
    return __removeAllowImpersonationUser;
}
//# sourceMappingURL=http.impl.js.map